import { defineStore } from 'pinia'
import { locale } from '@/core/data/i18n'
import { Role } from '@/types/auth'
import router from '@/router'

interface User {
  id: string
  name: string
  email: string
  rol: string,
  img: string
}

interface AuthState {
  user: User | null
  token: string
  locale: locale
  sites: Set<string>
}

export const useAuthStore = defineStore('auth', {
  persist: {
    storage: localStorage,
    serializer: {
      serialize: (state) => JSON.stringify({
        ...state,
        sites: Array.from(state.sites)
      }),
      deserialize: (state) => {
        const parsedState = JSON.parse(state)

        return {
          ...parsedState,
          sites: new Set(parsedState.sites)
        }
      }
    }
  },
  state: (): AuthState => ({
    user: null,
    token: '',
    locale: 'es',
    sites: new Set()
  }),
  actions: {
    setToken(token: string) {
      this.token = token
      this.user = this.parseJwt()
    },
    async logOut() {
      localStorage.clear()
      this.$reset()

      await router.replace('/auth/login')
    },
    parseJwt() {
      let base64Url = this.token.split('.')[1]
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      let jsonPayload = decodeURIComponent(atob(base64).split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''))

      return JSON.parse(jsonPayload)
    },
    showDashboardAlarms() {
      return this.user?.rol === Role.Administrador || this.user?.rol === Role.Monitorista
    },
    showTopbarShortcuts() {
      return this.user?.rol === Role.Administrador || this.user?.rol === Role.Monitorista || this.user?.rol === Role.Mantenimiento
    },
    isOperativeRole() {
      return this.user?.rol === Role.Operativo
    },
    isSupportRole() {
      return this.user?.rol === Role.Soporte
    }
  }
})